export const setDocumentTitle = (value: string) => {
  let v = value;
  if (!v.length) v = 'Untitled';
  if (document) document.title = `${v} - Floor Plan Lab`;
};
